import { atcb_action as atcbAction } from 'add-to-calendar-button';

//event Single add Add-to-calendar-button action to button in event info block
const atcbButton = document.getElementById('event-info__atcb-btn');

if (atcbButton) {
  const dataAtcb = window.atcbDatas;

  const config = {
    name: dataAtcb.name,
    startDate: dataAtcb.startDate,
    location: dataAtcb.location,
    options: ['Google', 'iCal', 'Apple', 'Outlook.com', 'Yahoo'],
    timeZone: dataAtcb.timeZone,
  };
  if (dataAtcb.startTime) {
    config.startTime = dataAtcb.startTime;
  }
  if (dataAtcb.endDate) {
    config.endDate = dataAtcb.endDate;
  }
  if (dataAtcb.endTime) {
    config.endTime = dataAtcb.endTime;
  }

  atcbButton.addEventListener('click', () => {
    atcbAction(config, atcbButton);
  });
}
